// components/Loader.jsx
"use client"
import React from 'react'
import styles from '@/styles/Loader.module.css' // <-- Path should point to the new CSS

/**
 * Modern Wavy Dots Loader Component
 * @param {object} props - Component props
 * @param {string} [props.color='currentColor'] - Color of the dots.
 * @param {string} [props.size='10px'] - Diameter of each dot.
 */
const Loader = ({ color = 'currentColor', size = '10px' }) => {

    // Set color and size via inline CSS variables
    const loaderStyle = {
        '--loader-dot-color': color,
        '--loader-dot-size': size,
        height: "10vh",
        minHeight: "10vh",
    }

    return (
        <div
            className={styles.wavyLoaderContainer}
            style={loaderStyle}
        >
            <div className={styles.dot}></div>
            <div className={styles.dot}></div>
            <div className={styles.dot}></div>
            <div className={styles.dot}></div>
        </div>
    )
}

export default Loader